/* eslint-disable */
import storage from 'local-storage-fallback';

$(window).on('load', function() {

  /*-------------------------------------------
        Welcome Message
     ---------------------------------------------*/
  function notify(message, type){
    //     $.growl({
    //         message: message
    //     },{
    //         type: type,
    //         allow_dismiss: false,
    //         label: 'Cancel',
    //         className: 'btn-xs btn-inverse',
    //         placement: {
    //             from: 'bottom',
    //             align: 'left'
    //         },
    //         delay: 2500,
    //         animate: {
    //             enter: 'animated fadeInUp',
    //             exit: 'animated fadeOutDown'
    //         },
    //         offset: {
    //             x: 30,
    //             y: 30
    //         }
    //     });
  }

  setTimeout(function () {
    if (!$('.login-content')[0]) {
      notify('Welcome back Mallinda Hollaway', 'inverse');
    }
  }, 1000)
});

/*----------------------------------------------------------
    Page Loader
 -----------------------------------------------------------*/
$(window).on('load', function() {
  setTimeout(function(){
    $('body').removeClass('loading');
  }, 500);
});
$(window).on('beforeunload', function(e) {
  if (document.activeElement) {
    var elemClass = document.activeElement.className;
    if (elemClass.indexOf('prevent-loading-spinner') === -1) {
      var suppressLoadingClass = Boolean(storage.getItem("suppressLoadingClass"));
      if (!suppressLoadingClass) {
        document.querySelector('body').className += ' loading';
      } else {
        storage.setItem("suppressLoadingClass", false);
      }
    }
  }
  // don't show the browser generated pop-up.
  return undefined;
});

$(document).ready(function(){

  /*----------------------------------------------------------
        Scrollbar
    -----------------------------------------------------------*/
  function scrollBar(selector, theme, mousewheelaxis) {
    // $(selector).mCustomScrollbar({
    //     theme: theme,
    //     scrollInertia: 100,
    //     axis:'yx',
    //     mouseWheel: {
    //         enable: true,
    //         axis: mousewheelaxis,
    //         preventDefault: true
    //     }
    // });
  }

  if (!$('html').hasClass('ismobile')) {
    //On Custom Class
    if ($('.c-overflow')[0]) {
      scrollBar('.c-overflow', 'minimal-dark', 'y');
    }
  }


  /*----------------------------------------------------------
        Dropdown Menu
    -----------------------------------------------------------*/
  if($('.dropdown')[0]) {

    $('.dropdown').on('shown.bs.dropdown', function (e) {
      if($(this).attr('data-animation')) {
        $animArray = [];
        $animation = $(this).data('animation');
        $animArray = $animation.split(',');
        $animationIn = 'animated '+$animArray[0];
        $animationOut = 'animated '+ $animArray[1];
        $animationDuration = ''
        if(!$animArray[2]) {
          $animationDuration = 500; //if duration is not defined, default is set to 500ms
        }
        else {
          $animationDuration = $animArray[2];
        }

        $(this).find('.dropdown-menu').removeClass($animationOut)
        $(this).find('.dropdown-menu').addClass($animationIn);
      }
    });

    $('.dropdown').on('hide.bs.dropdown', function (e) {
      if($(this).attr('data-animation')) {
        e.preventDefault();
        $this = $(this);
        $dropdownMenu = $this.find('.dropdown-menu');

        $dropdownMenu.addClass($animationOut);
        setTimeout(function(){
          $this.removeClass('open')

        }, $animationDuration);
      }
    });
  }

  /*----------------------------------------------------------
        Auto Size Textarea
    -----------------------------------------------------------*/
  if ($('.auto-size')[0]) {
    autosize($('.auto-size'));
  }


  /*----------------------------------------------------------
        Text Field
    -----------------------------------------------------------*/
  //Add blue animated border and remove with condition when focus and blur
  // if($('.fg-line')[0]) {
  $('body').on('focus', '.fg-line .form-control', function(){
    $(this).closest('.fg-line').addClass('fg-toggled');
  })
  $('body').on('blur', '.form-control', function(){
    var p = $(this).closest('.form-group, .input-group');
    var i = p.find('.form-control').val();

    if (p.hasClass('fg-float')) {
      if (!i || i.length == 0) {
        $(this).closest('.fg-line').removeClass('fg-toggled');
      }
    }
    else {
      $(this).closest('.fg-line').removeClass('fg-toggled');
    }
  });
  // }

  //Add blue border for pre-valued fg-flot text feilds
  if($('.fg-float')[0]) {
    $('.fg-float .form-control').each(function(){
      var i = $(this).val();

      if (i && i.length !== 0) {
        $(this).closest('.fg-line').addClass('fg-toggled');
      }

    });
  }


  /*----------------------------------------------------------
        Audio and Video Player
    -----------------------------------------------------------*/
  if($('audio, video')[0]) {
    $('video,audio').mediaelementplayer();
  }


  /*-----------------------------------------------------------
        Summernote HTML Editor
    -----------------------------------------------------------*/
  if ($('.html-editor')[0]) {
    $('.html-editor').summernote({
      height: 150
    });
  }

  if($('.html-editor-click')[0]) {
    //Edit
    $('body').on('click', '.hec-button', function(){
      $('.html-editor-click').summernote({
        focus: true
      });
      $('.hec-save').show();
    })

    //Save
    $('body').on('click', '.hec-save', function(){
      $('.html-editor-click').code();
      $('.html-editor-click').destroy();
      $('.hec-save').hide();
      notify('Content Saved Successfully!', 'success');
    });
  }

  //Air Mode
  if($('.html-editor-airmod')[0]) {
    $('.html-editor-airmod').summernote({
      airMode: true
    });
  }


  /*-----------------------------------------------------------
        Date Time Picker
    -----------------------------------------------------------*/
  //Date Time Picker
  if ($('.date-time-picker')[0]) {
    $('.date-time-picker').datetimepicker();
  }

  //Time
  if ($('.time-picker')[0]) {
    $('.time-picker').datetimepicker({
      format: 'LT'
    });
  }

  //Date
  if ($('.date-picker')[0]) {
    $('.date-picker').datetimepicker({
      format: 'DD/MM/YYYY'
    });
  }

  $('.date-picker').on('dp.hide', function(){
    $(this).closest('.dtp-container').removeClass('fg-toggled');
    $(this).blur();
  })


  /*-----------------------------------------------------------
        Form Wizard
    -----------------------------------------------------------*/
  if ($('.form-wizard-basic')[0]) {
    $('.form-wizard-basic').bootstrapWizard({
      tabClass: 'fw-nav',
      'nextSelector': '.next',
      'previousSelector': '.previous'
    });
  }


  /*-----------------------------------------------------------
        Link prevent
    -----------------------------------------------------------*/
  $('body').on('click', '.a-prevent', function(e){
    e.preventDefault();
  });


  /*----------------------------------------------------------
        Bootstrap Accordion Fix
    -----------------------------------------------------------*/
  if ($('.collapse')[0]) {

    //Add active class for opened items
    $('.collapse').on('show.bs.collapse', function (e) {
      $(this).closest('.card').find('.card-header').addClass('active');
    });

    $('.collapse').on('hide.bs.collapse', function (e) {
      $(this).closest('.card').find('.card-header').removeClass('active');
    });

    //Add active class for pre opened items
    $('.collapse.in').each(function(){
      $(this).closest('.card').find('.card-header').addClass('active');
    });
  }


  /*-----------------------------------------------------------
        Tooltips
    -----------------------------------------------------------*/
  if ($('[data-toggle="tooltip"]')[0]) {
    $('[data-toggle="tooltip"]').tooltip();
  }


  /*-----------------------------------------------------------
        Popover
    -----------------------------------------------------------*/
  if ($('[data-toggle="popover"]')[0]) {
    $('[data-toggle="popover"]').popover();
  }


  /*-----------------------------------------------------------
        IE 9 Placeholder
    -----------------------------------------------------------*/
  if($('html').hasClass('ie9')) {
    $('input, textarea').placeholder({
      customClass: 'ie9-placeholder'
    });
  }


  /*-----------------------------------------------------------
        Dropzone Uploader
    -----------------------------------------------------------*/
  if($('.dropzone')[0]) {
    Dropzone.autoDiscover = false;
    $('#dropzone-upload').dropzone({
      url: "/file/post",
      addRemoveLinks: true

    });
  }

});
